if (window.matchMedia('(min-width: 767px)').matches) {
  var pagetop = $('#pagetop');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 800) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
} else {
  var pagetop = $('#pagetop');
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
}
